import propEq from "ramda/src/propEq";

export const propL1IdEq = propEq("l1Id");
